import styled from 'styled-components';

export const Numbers1 = styled.p`
  font-size: 32px;
  line-height: 1;
  letter-spacing: 0.01em;
  font-style: normal;
  margin: 0;
`;
